/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerQuickInsightsThresholdSetting } from '../../models/customer-quick-insights-threshold-setting';
import { CustomerQuickInsightsThresholdSettingDto } from '../../models/customer-quick-insights-threshold-setting-dto';

export interface UpdateSetting_2$Params {
  settingId: number;
      body: CustomerQuickInsightsThresholdSettingDto
}

export function updateSetting_2(http: HttpClient, rootUrl: string, params: UpdateSetting_2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
  const rb = new RequestBuilder(rootUrl, updateSetting_2.PATH, 'put');
  if (params) {
    rb.path('settingId', params.settingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerQuickInsightsThresholdSetting>;
    })
  );
}

updateSetting_2.PATH = '/api/customer/quickInsight/threshold/setting/{settingId}';
